// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import { useFlexFlagIsOn } from '@indeed/flex-feature-flags'

import { TrackingTrigger, TrackingProvider } from '@indeed/flex-tracking-context'

import PageView from 'syft-acp-core/components/PageView'
import WorkerStrikeDetails from 'syft-acp-core/entities/WorkerStrikes/WorkerStrikeDetails'
import { SAVE_BUTTON_EVENT } from 'syft-acp-core/entities/WorkerStrikes/WorkerStrikeDetails/WorkerStrikeDetails.helpers'
import { recordLabel, useWorkerName } from 'syft-acp-core/components/PageTitle'
import { WorkerSubNavigation } from './SubNavigation'
import { trackingEvents } from './EntityWorkersStrikesNew.tracking'
import { RouteComponentProps } from 'react-router-dom'

type Props = RouteComponentProps<{
  id: string
}>

export const EntityWorkersStrikesNew = ({ match: { params } }: Props) => {
  const workerName = useWorkerName(Number(params.id))
  const isNegativeAction = useFlexFlagIsOn('pte_34577_negative_actions')

  return (
    <TrackingProvider
      value={{
        context: {
          worker_id: params.id,
        },
        eventMappings: event => (event === SAVE_BUTTON_EVENT ? trackingEvents.SAVE_BUTTON.CLICKED : event),
      }}
    >
      <TrackingTrigger onLoad={{ event: trackingEvents.PAGE.VIEWED }} />
      <WorkerSubNavigation workerID={params.id} />
      <PageView
        title={[
          isNegativeAction ? 'New negative action' : 'New strike',
          recordLabel('Worker', params.id, workerName),
        ]}
      >
        <WorkerStrikeDetails workerID={Number(params.id)} id={0} />
      </PageView>
    </TrackingProvider>
  )
}
